function init(subscribe) {
    if (window.allianzAddonId == undefined) {
        return;
    }

    subscribe((calcRes) => {
        $('.allianz-consents').toggle(calcRes.addonIds.includes(allianzAddonId));
    });
}

export default init;